module.exports = __webpack_public_path__ + "img/V-mini.a42cf467.jpg";